var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9453 6.38672C17.8789 4.98438 17.5586 3.74219 16.5312 2.71875C15.5078 1.69531 14.2656 1.375 12.8633 1.30469C11.418 1.22266 7.08594 1.22266 5.64062 1.30469C4.24219 1.37109 3 1.69141 1.97266 2.71484C0.945312 3.73828 0.628906 4.98047 0.558594 6.38281C0.476562 7.82812 0.476562 12.1602 0.558594 13.6055C0.625 15.0078 0.945312 16.25 1.97266 17.2734C3 18.2969 4.23828 18.6172 5.64062 18.6875C7.08594 18.7695 11.418 18.7695 12.8633 18.6875C14.2656 18.6211 15.5078 18.3008 16.5312 17.2734C17.5547 16.25 17.875 15.0078 17.9453 13.6055C18.0273 12.1602 18.0273 7.83203 17.9453 6.38672ZM9.25391 5.50781C6.76953 5.50781 4.76562 7.51172 4.76562 9.99609C4.76562 12.4805 6.76953 14.4844 9.25391 14.4844C11.7383 14.4844 13.7422 12.4805 13.7422 9.99609C13.7422 7.51172 11.7383 5.50781 9.25391 5.50781ZM9.25391 12.9141C7.64844 12.9141 6.33594 11.6055 6.33594 9.99609C6.33594 8.38672 7.64453 7.07812 9.25391 7.07812C10.8633 7.07812 12.1719 8.38672 12.1719 9.99609C12.1719 11.6055 10.8594 12.9141 9.25391 12.9141ZM14.9727 5.32422C14.9727 5.90625 14.5039 6.37109 13.9258 6.37109C13.3438 6.37109 12.8789 5.90234 12.8789 5.32422C12.8789 4.74609 13.3477 4.27734 13.9258 4.27734C14.5039 4.27734 14.9727 4.74609 14.9727 5.32422Z",
    fill: "#8C7C73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1a4c77a3.svg";
export { ForwardRef as ReactComponent };